import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

const RankingListItemWrapper = styled.div<{ theme: Theme }>`
  border: 1px solid ${getColor('borderSecondary')};
  margin: 0 0 32px 0;
  padding: 16px 16px 112px 16px;
  position: relative;
  transition: all 0.2s;

  @media (${breakpoint.mdMin}) {
    margin: 0 0 24px 0;
  }

  @media (${breakpoint.xlMin}) {
    margin: 0 0 48px 0;
  }

  .image,
  .rank {
    margin: -32px 0 16px 0;
    position: relative;
    width: 100%;
  }

  .image {
    transition: 0.35s ease-in-out;

    &:hover {
      filter: brightness(80%);
      transition: 0.35s ease-in-out;
    }
  }

  .rank {
    display: flex;
    height: 64px;
    background-color: ${getColor('surfaceBlack')};
    justify-content: space-between;

    img[src*='.png'] {
      background-color: ${getColor('surfaceWhite')};
    }
  }

  .title {
    ${getBodyStyle('graphikCond', { default: 'xlarge' }, 'semiBold')};
    text-align: left;
    text-decoration: none;
    &:hover {
      color: ${getColor('textLink')};
    }
  }

  .excerpt {
    ${getBodyStyle('graphikCompact', { default: 'default' })};
    margin: 24px 0 16px 0;
    text-align: left;
  }

  .bottom-container {
    bottom: 0;
    left: 0;
    padding: 0 16px 16px 16px;
    position: absolute;
    width: 100%;
  }

  .black-button {
    width: 100%;
    text-transform: uppercase;
  } 
`;

export default RankingListItemWrapper;
